import React from 'react';
import { PolicyFromText } from '../../components/ui/PolicyFromText';
import { contactInformation } from '../../data/policies/contact';
export function ContactInformation() {
  return <PolicyFromText doc={contactInformation} data-id="element-1164" data-mp="27qnksf77ke9j" />;
}